<template>
  <v-card flat>
    <v-card-title> Events summary </v-card-title>
    <v-data-table
      :headers="[
        { text: 'Date', value: 'date' },
        { text: 'Freq Recovery Rate', value: 'freqRecoveryRate' },
        { text: 'Nadir', value: 'nadir' },
        { text: 'Freq Settling', value: 'freqSettling' },
        { text: 'ROCOF', value: 'rocof' },
        { text: 'Final Offset', value: 'steadyStateOffset' },
        { text: 'Time To Nadir', value: 'timeToNadir' },
      ]"
      :items="outputs"
      class="elevation-1"
      dense
      disable-pagination
      hide-default-footer
    >
      <template v-slot:item.date="{ item }">
        <span v-if="item.date">
          <span class="text-caption grey--text">
            {{ formatDate(item.date) }}
          </span>
          {{ formatTime(item.date) }}
        </span>
        <span v-else>-</span>
      </template>
      <template v-slot:item.freqRecoveryRate="{ item }">
        <span v-if="item.freqRecoveryRate !== undefined">
          {{ item.freqRecoveryRate.toFixed(2) }} Hz/s
        </span>
        <span v-else>-</span>
        <v-icon
          v-if="item.freqRecoveryRate === undefined || item.freqRecoveryRate < 0.01"
          color="warning"
          small
          class="ml-1"
          title="Warning: Frequency recovery rate is zero or missing"
        >
          mdi-alert
        </v-icon>
      </template>
      <template v-slot:item.freqSettling="{ item }">
        <span v-if="item.freqSettling != null">
          {{ item.freqSettling.toFixed(2) }} Hz
          <span v-if="item.freqSettlingStd !== undefined" class="text-caption grey--text">
            ±{{ item.freqSettlingStd.toFixed(2) }}
          </span>
        </span>
        <span v-else class="text-caption grey--text"> did not settle </span>
      </template>
      <template v-slot:item.nadir="{ item }">
        <span v-if="item.nadir !== undefined"> {{ item.nadir.toFixed(2) }} Hz </span>
        <span v-else>-</span>
      </template>
      <template v-slot:item.rocof="{ item }">
        <span v-if="item.rocof !== undefined"> {{ item.rocof.toFixed(2) }} Hz/s </span>
        <span v-else>-</span>
      </template>
      <template v-slot:item.steadyStateOffset="{ item }">
        <span v-if="item.steadyStateOffset !== undefined">
          {{ item.steadyStateOffset.toFixed(2) }} mHz
        </span>
        <span v-else>-</span>
      </template>
      <template v-slot:item.timeToNadir="{ item }">
        {{ item.timeToNadir !== undefined ? item.timeToNadir.toFixed(2) : "-" }} s
        <span v-if="item.timeSimulated !== undefined" class="text-caption grey--text">
          out of {{ item.timeSimulated.toFixed(2) }}
        </span>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { DateTime } from "luxon";

export default {
  name: "TStabilityDashboard",
  components: {},
  mixins: [],
  props: {
    outputs: { type: Array, required: true },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    formatDate(date) {
      return DateTime.fromISO(date, { zone: "utc" }).toFormat("dd LLL yyyy");
    },
    formatTime(date) {
      return DateTime.fromISO(date, { zone: "utc" }).toFormat("HH:mm");
    },
  },
};
</script>

<style></style>
